import { IEmployeeAppArchivedInstance } from '@dadohr/shared/domainTypes/experience';
import { usePromise } from '../../../../../hooks/usePromise';
import { callFirebaseFunction } from '../../../../../services/firebaseFunctions';

const OWN_CACHE: {
  [userAccessToken: string]: Promise<IEmployeeAppArchivedInstance[]>;
} = {};

const OTHER_CACHE: {
  [userAccessToken: string]: Promise<IEmployeeAppArchivedInstance[]>;
} = {};

const getOwnArchivedInstances = async (userAccessToken: string) => {
  return await callFirebaseFunction<IEmployeeAppArchivedInstance[]>(
    'standaloneApp_getArchivedInstances',
    {
      userAccessToken,
      opts: {
        mode: 'participant'
      }
    }
  );
};

export const useOwnArchivedInstances = (userAccessToken: string) => {
  return usePromise(() => {
    if (!OWN_CACHE[userAccessToken]) {
      OWN_CACHE[userAccessToken] = getOwnArchivedInstances(userAccessToken);
    }
    return OWN_CACHE[userAccessToken];
  }, [userAccessToken]);
};

const getOtherArchivedInstances = async (userAccessToken: string) => {
  return await callFirebaseFunction<IEmployeeAppArchivedInstance[]>(
    'standaloneApp_getArchivedInstances',
    {
      userAccessToken,
      opts: {
        mode: 'supportingActor'
      }
    }
  );
};

export const useOtherArchivedInstances = (userAccessToken: string) => {
  return usePromise(() => {
    if (!OTHER_CACHE[userAccessToken]) {
      OTHER_CACHE[userAccessToken] = getOtherArchivedInstances(userAccessToken);
    }
    return OTHER_CACHE[userAccessToken];
  }, [userAccessToken]);
};
